import nwApi from '../nwApi'

export default function (param) {
    nwApi.common('analysis',param)
}